import React, { useEffect, useState } from 'react';
import TimePicker from 'rc-time-picker';
import 'rc-time-picker/assets/index.css'; // Import the default styles
import moment, { Moment } from 'moment'; // Import moment for Date and Moment conversions

type PropsTimePickerComponent = {
    onChange: (e:Moment) => void,
    onValidateChange?:(e:Moment) => boolean,    
    disabled?:boolean
    min?:string
    max?:string
    value:string|null 
}

const TimePickerComponent = (props:PropsTimePickerComponent) => {
  const [selectedTime, setSelectedTime] = useState<Moment | undefined>(undefined);
  
  const {onValidateChange} = props

  useEffect(() => {
    if(props.value !== null && props.value !== undefined){
      setSelectedTime(moment(props.value, 'HH:mm'))
    }
    else {
      setSelectedTime(undefined)
    }
  }, [props.value])
  


  const handleTimeChange = (value: Moment | null) => {

    

    if (value !== null  ) {
      var changeValue:boolean = true;
      
      if(typeof(onValidateChange) === "function" ){
        changeValue = onValidateChange(value)
      }

      if(changeValue){
        setSelectedTime(value);
        props.onChange(value)
      }
      
      
    } else {
      setSelectedTime(undefined);
      
    }
  };

  return (
    <div>
      <TimePicker
        showSecond={false}
        //value={selectedTime} // Initial value (optional)
        onChange={handleTimeChange} // Callback on time change
        format={'HH:mm a'} // Display format
        disabled = {props.disabled !== undefined && props.disabled === true}
        allowEmpty={false}
        inputReadOnly={false}
        //open={false}
      />      
    </div>
  );
};

export default TimePickerComponent;